import axios from 'axios'
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    userId: 0,
    users: [],
    leagues: [],
    teams: [],
    algorithms: [],
    algorithm_result: [],
    compare_result: null,
    enableClear: false
  },
  mutations: {
    SET_USERID(state, id) {
      state.userId = id
    },
    SET_VERIFY(state, info) {
      // console.log('SET_VERIFY', info)
      Vue.set(state, 'users', info.users)
      Vue.set(state, 'leagues', info.leagues)
    },
    SET_TEAMS(state, info) {
      Vue.set(state, 'teams', info)
    },
    SET_ALGORITHMs(state, info) {
      Vue.set(state, 'algorithms', info)
    },
    SET_ALGORITHM_RESULT(state, info) {
      Vue.set(state, 'algorithm_result', info)
    },
    SET_COMPARE_RESULT(state, info) {
      Vue.set(state, 'compare_result', info)
    },
    SET_CLEAR_ENABLE(state, enable) {
      console.log('SET_CLEAR_ENABLE', enable)
      state.enableClear = enable
    }
  },
  actions: {
    async fetchVerifyInfo({ commit, rootState }, params) {
      try {
        // console.log("params: " + JSON.stringify(new_params));
        const response = await axios.get('https://api.ip008.com/odds/verify.php', {
          params: params
        })
        
        commit('SET_VERIFY', response.data)
        // console.log('state after setting', this.state)
      } catch (error) {
        console.error('Error fetching verify data:', error)
      }
    },
    async fetchTeamsInfo({ commit, rootState }, params) {
      try {
        // console.log("params: " + JSON.stringify(new_params));
        const response = await axios.get('https://api.ip008.com/odds/verify.php', {
          params: params
        })
        console.log('fetchTeamsInfo response: ', response)
        commit('SET_TEAMS', response.data.teams)
        commit('SET_ALGORITHMs', response.data.algorithms)
        // console.log('state after setting', this.state)
      } catch (error) {
        console.error('Error fetching verify data:', error)
      }
    },
    async verifyAlgorithm({ commit, rootState }, params) {
      try {
        const response = await axios.post('https://api.ip008.com/odds/verify.php?a=verify', params);
        // console.log("verifyAlgorithm params: " + JSON.stringify(params));
        // const response = await axios.get('https://api.ip008.com/odds/verify.php', {
        //   params: params
        // })
        console.log('verifyAlgorithm response: ', response)
        commit('SET_ALGORITHM_RESULT', response.data)
      } catch (error) {
        console.error('Error fetching verify data:', error)
      }
    },
    // Phase 0：在同一批比赛上对比多个算法（不传 algo_ids 时后端默认对比全部）。
    async compareAlgorithms({ commit, rootState }, params) {
      try {
        const response = await axios.post('https://api.ip008.com/odds/verify.php?a=compare', params);
        console.log('compareAlgorithms response: ', response)
        commit('SET_COMPARE_RESULT', response.data)
      } catch (error) {
        console.error('Error comparing algorithms:', error)
      }
    },
    enableClear({ commit }, data) {
      commit('SET_CLEAR_ENABLE', data);
    }
  }
}
